import { AfterViewInit, Component } from '@angular/core';
import { 
  GetHomeDetailRequest, IIfcFileArtifact, IIfcFileVersion, IfcFile, IfcType, TempIfcFileError, TempIfcFile, GetIfcFileUploadStatusRequest, GetIfcFileUploadStatusResponse,
  ClearIfcFileUploadErrorRequest, ClearIfcFileUploadErrorResponse, GetHomeDetailResponse, IfcParseError, ListPagedIfcErrorsRequest, ListPagedIfcErrorsResponse, 
  ListIfcFilesByHomeIdResponse,
  HomeIfcFile,
  ListIfcFilesByHomeIdRequest,
  GetHomeIdRequest,
  GetHomeIdResponse
} from 'situview-webapi-client';
import { 
  CustomSituViewWebApiClient, BreadcrumbService, StateService, HomeService, IProductNameConfiguration, ProductNameService, AuthService, IfcService, Utils
} from 'src/app/services';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from "@angular/material/snack-bar";
import { interval, Subscription } from 'rxjs';
import { GetMostPopularRenderedHomesByBuilderRequest, GetMostPopularRenderedHomesByBuilderResponse } from 'situanalytics-webapi-client';
import { CreateGenericArtifactRequest, CreateGenericArtifactResponse, EnvironmentName, GetRenderReportRequest, GetRenderReportResponse, HomeStatus, ProductName, RenderReportType, SituRenderServiceWebApiClient } from 'siturenderservice-webapi-client';
import { IIfcFileQuery } from 'src/app/components';
import { FormControl } from '@angular/forms';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';

@Component({
  selector: 'app-home-detail',
  templateUrl: './home-detail.component.html',
  styleUrls: ['./home-detail.component.scss'],
})
export class HomeDetailComponent extends SituBaseComponent {
  home: string = '';

  selectedProduct: IProductNameConfiguration | undefined;
  products: IProductNameConfiguration[] | undefined;

  tabs = ["products", "zones", "storeys", "warnings", "errors"];
  tempIfcFileErrors: TempIfcFileError[] = [];
  tempIfcFiles: TempIfcFile[] = [];

  uploading: boolean = false;
  IfcTypeEnum = IfcType;

  ifcFileArtifacts: IIfcFileArtifact[] | undefined;
  filteredIfcFileArtifacts: IIfcFileArtifact[] | undefined;
  searchField = new FormControl();
  searchText: string = "";

  ifcOptions: string[] = ["products", "zones", "storeys", "warnings", "errors" ];
  selectedIfc: IIfcFileArtifact | undefined;
  selectedIfcVersion: IIfcFileVersion | undefined;
  selectedIfcOption: string | undefined;
  options: string[] | undefined;

  ifcFilesLoading: boolean = false;
  homeIfcFiles: IfcFile[] | undefined;
  homeIfcFileErrors: IfcParseError[] | undefined;
  isNotErrorFeed: boolean = true;

  viewsChartLoading: boolean = false;
  public viewsChartLabels: string[] = [];
  public viewsChartData: any[] = [];
  public viewsChartColors: Array<string> = [];

  renderChartLoading: boolean = false;
  public renderAverage: number | undefined;
  public renderChartData: Array<any> = [];
  public renderChartLabels: Array<string> = [];
  public renderChartColors: Array<string> = [];

  private _getIfcFileUploadStatusSubscription = new Subscription();
  
  private _showLoading = false;
  public get showLoading(): boolean {
    return this._showLoading;
  }

  public set showLoading(val: boolean) {
    this._showLoading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  constructor(
      authService: AuthService,
      stateService: StateService,
      private route: ActivatedRoute,
      private router: Router,
      private situViewClient: CustomSituViewWebApiClient,
      private snackBar: MatSnackBar,
      private breadcrumbService: BreadcrumbService,
      private homeService: HomeService,
      private productNameService: ProductNameService,
      private ifcService: IfcService,
      private renderServiceClient: SituRenderServiceWebApiClient) {
    super(authService, stateService);
    this.home = this.route.snapshot.paramMap.get('home') ?? '';
    this.breadcrumbService.setParam(":home", this.home);

    this.products = this.productNameService.productNameConfigurations;
    this.selectedProduct = this.productNameService.productNameConfiguration;
  }

  protected onSelectedCompanyChange(): void {
    if (this.selectedCompany?.id) {
      if (this.isAdmin || this.isSituUser) {
          this.getIfcFileUploadStatus();
          this.pollGetIfcFileUploadStatus();
      }
      this.loadHomeDetail();
      this.loadMostPopularHomes();
      this.loadRenderTimesChart();
      this.loadIfcReportData();
      this.loadIfcReportErrorData();
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this._getIfcFileUploadStatusSubscription) {
      this._getIfcFileUploadStatusSubscription.unsubscribe();
    }
  }

  generateIFCPreview(artifactFile: IIfcFileArtifact) {
      let request = new CreateGenericArtifactRequest();
      request.companyId = this.selectedCompany?.id;
      request.callerReferenceKey = `ifcpreview\\${this.selectedCompany?.code}\\${this.home}\\${(artifactFile.isMaster ? 'master' : 'option')}\\${artifactFile.name}`;
      request.environment = EnvironmentName.Latest;
      request.environmentToUse = ProductName.Panorama;

      this.renderServiceClient.createGenericArtifact(request)
          .then((response: CreateGenericArtifactResponse) => {
            if (response.success) {
              if (response.status === HomeStatus.Complete) {
                this.showMessage("Your IFC preview is complete!");
              } else {
                this.showMessage("We are generating your IFC preview!");
              }
            }
          });
  }

  handleChartClick(config: string) {
    //console.log(config);
  }

  selectIfcFile(ifcFile: IIfcFileArtifact) {
    if (ifcFile) {
      this.selectedIfc = ifcFile;
    } else {
      this.selectedIfc = ifcFile;
      this.selectedIfcVersion = ifcFile;
      this.selectedIfcOption = ifcFile;
    }
    this.updateURLParams();
  }
  
  selectIfcFileVersion(ifcFileVersion: IIfcFileVersion) {
    if (ifcFileVersion) {
      this.selectedIfcVersion = ifcFileVersion;
    } else {
      this.selectedIfcVersion = ifcFileVersion;
      this.selectedIfcOption = ifcFileVersion;
    }
    this.updateURLParams();
  }

  selectIfcOption(option: string) {
    if (option) {
      this.selectedIfcOption = option;
      switch(option) {
        case "warnings":
          this.options = this.selectedIfcVersion?.warnings;
          break;
        case "errors":
          this.options = this.selectedIfcVersion?.errors;
          break;
        case "storeys":
          this.options = this.selectedIfcVersion?.storeys;
          break;
        case "zones":
          this.options = this.selectedIfcVersion?.zones;
          break;
        default:
          this.options = this.selectedIfcVersion?.products;
          break;
      }
    } else {
      this.selectedIfcOption = option;
      this.options = undefined;
    }
    this.updateURLParams();
  }

  getIfcOptionCount(ifcFileVersion: IIfcFileVersion, option: string ) {
    switch(option) {
      case "zones":
        return ifcFileVersion.zones?.length;
      case "storeys":
        return ifcFileVersion.storeys?.length;
      case "warnings":
        return ifcFileVersion.warnings?.length;
      case "errors":
        return ifcFileVersion.errors?.length;
      default:
        return ifcFileVersion.products?.length;
    }
  }

  isRecent(uploadTime: Date) {
    let date = new Date();
    date.setHours(date.getHours() - 12);
    return uploadTime > date; 
  }

  productChange(product: any) {
    this.renderAverage = undefined;
    this.selectedProduct = product.value;
    this.productNameService.productNameConfiguration = product.value;
    this.loadRenderTimesChart();
  };

  updateURLParams() {
    this.router.navigate(['.'], { relativeTo: this.route, 
      queryParams: { 
        ifcFile: this.selectedIfc?.name,
        v: this.selectedIfcVersion?.version,
        tab: this.selectedIfcOption
      }
    });
  }

  showUploadFiles() {
    this.router.navigate([`/homes/upload`], { queryParams: { home: this.home }});
    return;
  }

  clearError(error: TempIfcFileError) {
    let request = new ClearIfcFileUploadErrorRequest();
    request.builder = this.selectedCompany?.code;
    request.homeName = error.home;
    request.id = error.id;

    this.situViewClient.clearIfcFileUploadError(request)
      .then(response => {
        let clearIfcFileUploadErrorResponse = response as ClearIfcFileUploadErrorResponse;
        if (clearIfcFileUploadErrorResponse.success) {
          this.tempIfcFileErrors = this.tempIfcFileErrors.filter(x => x.id !== error.id);
        }
      });
  }

  handleIfcFeedFileSelection(query: IIfcFileQuery) {
    this.handleIfcFileQuery(query);
    this.updateURLParams();
  }

  labelFormatter (tick: string) {
    return tick.split("_")[0];
  } 

  doFilter = (value: string) => {
    if (value) {
      let searchTerm = value.trim().toLocaleLowerCase();
      this.filteredIfcFileArtifacts = this.ifcFileArtifacts?.filter(e => { return e.name?.toLocaleLowerCase().includes(searchTerm)});
    } else {
      this.filteredIfcFileArtifacts = this.ifcFileArtifacts;
    }
  }

  capitalizeFirstLetter(text: string) {
    return Utils.capitalizeFirstLetter(text);
  };

  getEstimatedRenderTime() {
    if (this.selectedProduct && this.renderAverage) {
      return `${this.renderAverage}s`;
    }
    return "Not Available";
  };

  private loadHomeDetail() {
    let request = new GetHomeDetailRequest();
    request.builder = this.selectedCompany?.code;
    request.home = this.home;

    if(!request.home){
      return;
    }

    this.showLoading = true;
    this.situViewClient.getHomeDetail(request)
      .then((response: any)  => {
        let getHomeDetailResponse = response as GetHomeDetailResponse;
        if (getHomeDetailResponse.success && getHomeDetailResponse.ifcFiles?.length && getHomeDetailResponse.ifcFiles?.length > 0) {
          this.ifcFileArtifacts = getHomeDetailResponse.ifcFiles ?? [];
          this.filteredIfcFileArtifacts = this.ifcFileArtifacts;
  
          const ifcFileQuery = this.route.snapshot.queryParamMap.get('ifcFile');
          const versionQuery = this.route.snapshot.queryParamMap.get('v');
          const tabQuery = this.route.snapshot.queryParamMap.get('tab');
  
          this.handleIfcFileQuery({ "file": ifcFileQuery, "version": versionQuery, "tab": tabQuery } as IIfcFileQuery);
        } else {
          this.router.navigate([`/homes/dashboard`]);
          return;
        }

        this.showLoading = false;
      })
      .catch((err: any) => {
        this.showLoading = false;
      });
  };

  private handleIfcFileQuery(query: IIfcFileQuery) {
    if (query.file) {
      this.selectedIfc = this.ifcFileArtifacts?.length ? this.ifcFileArtifacts?.find(x => x.name == query.file) ?? this.ifcFileArtifacts[0] : undefined;

      if (this.selectedIfc) {
        this.selectedIfcVersion = this.selectedIfc.versions ? this.selectedIfc.versions[0] : undefined;
  
        if (query.version && query.file) {
          this.selectedIfcVersion = this.selectedIfc.versions ? this.selectedIfc.versions.find(x => x?.version?.toString() === query.version.toString()) ?? this.selectedIfc.versions[0] : undefined;
        } else {
          this.selectedIfcVersion = this.selectedIfc?.versions?.length ? this.selectedIfc.versions[0] : undefined;
        }
  
        if (query.tab) {
          this.selectedIfcOption = query.tab;
          this.selectIfcOption(query.tab);
        }
      }
    }
  };

  private loadRenderTimesChart() {
    this.renderChartLoading = true;
    this.renderChartColors = [];
    this.renderChartLabels = [];
    this.renderChartData = [];
    this.products?.forEach(color => {
      if (color.productName === this.selectedProduct?.productName) {
        this.renderChartColors.push(color.productColor);
      }
    });
    
    let renderReportRequest = new GetRenderReportRequest();
    renderReportRequest.companyId = this.selectedCompany?.id;
    renderReportRequest.productName = this.selectedProduct?.productName;
    renderReportRequest.type = RenderReportType.Last5RendersHomes;
    renderReportRequest.home = this.home;
    renderReportRequest.timePeriod = 10;
    return this.homeService.GetRenderChartData(renderReportRequest)
      .then((renderReportResponse: any) => {
        let response = renderReportResponse as GetRenderReportResponse;
        if (response.success) {
          
          let dataSet = [];
          for (let key in response.data) {
            let value = response.data[key];
            let homeConfig = Utils.getHomeConfigurationFromPath(key);

            let configuration = [];
            if (homeConfig?.masterFile) configuration.push(homeConfig?.masterFile);
            if (homeConfig?.themes) configuration.push(homeConfig?.themes);
            if (homeConfig?.options) configuration.push(homeConfig?.options);
            this.renderChartLabels.push(configuration.join("_"));
            dataSet.push(value);
          }
          this.renderAverage = Math.round(dataSet.reduce((a, b) => a + b, 0) / dataSet.length);
          this.renderChartData = [{ data: dataSet, label: response.label }];
        }
        this.renderChartLoading = false;
      })
      .catch(err => {
        this.renderChartLoading = false;
      });
  };

  private loadMostPopularHomes() {
    this.viewsChartLoading = true;
    this.viewsChartColors = [];
    this.viewsChartColors.push("rgba(56, 163, 165, 1)");

    let mostPopularHomesRequest = new GetMostPopularRenderedHomesByBuilderRequest();
    mostPopularHomesRequest.ownerId = this.selectedCompany?.id;
    mostPopularHomesRequest.pageSize = 5;
    mostPopularHomesRequest.home = this.home;
    mostPopularHomesRequest.daysPreviousToSearch = 1;
    this.homeService.GetMostPopularHomesByBuilder(mostPopularHomesRequest)
      .then((response: GetMostPopularRenderedHomesByBuilderResponse) => {
        if (response.success) {
          let dataSet: (number | undefined)[] = [];
          this.viewsChartLabels = [];
          response.logItems?.forEach(logItem => {
            let configuration = [];
            if (logItem.facade) configuration.push(logItem.facade);
            if (logItem.themes) configuration.push(logItem.themes);
            if (logItem.options) configuration.push(logItem.options);
            this.viewsChartLabels.push(configuration.join("_"));
            dataSet.push(logItem.numberOfViews);
          });
          this.viewsChartData = [{ data: dataSet, label: "Home views" }];
        }
        this.viewsChartLoading = false;
      })
      .catch((err: any) => {
        this.viewsChartLoading = false;
      });
  };

  private loadIfcReportData(loadEnvironments: boolean = true) {
    if (!this.selectedCompany?.id) {
      return;
    }

    this.ifcFilesLoading = true;

    let getHomeRequest = new GetHomeIdRequest()
    getHomeRequest.companyId = this.selectedCompany.id;
    getHomeRequest.home = this.home;
    this.situViewClient.getHomeId(getHomeRequest)
      .then((getHomeResponse: GetHomeIdResponse) => {
        let request = new ListIfcFilesByHomeIdRequest();
        request.companyId = this.selectedCompany?.id;
        request.orderLatest = true;
        request.justTen = true;
        request.homeId = getHomeResponse.homeId;
    
        this.situViewClient.listIfcFilesByHomeId(request)
          .then((response: ListIfcFilesByHomeIdResponse) => {
            if (response.success) {
              this.homeIfcFiles = response.ifcFiles?.map((x: HomeIfcFile) => {
                let homeIfcFile = new IfcFile();
                homeIfcFile.home = x.callerReferenceKey?.split('\\')[2];
                homeIfcFile.name = x.name;
                homeIfcFile.dateAdded = x.dateUpdated ?? new Date();
                homeIfcFile.version = x.version;
                return homeIfcFile;
              }) ?? [];
              this.ifcFilesLoading = false;
            }
          })
          .catch(err => {
            this.ifcFilesLoading = false;
          });
      })
  };
  
  private loadIfcReportErrorData() {
    this.ifcFilesLoading = true;

    var request = new ListPagedIfcErrorsRequest();
    request.builder = this.selectedCompany?.code;
    request.pageNumber = 1;
    request.pageSize = 10;
    request.home = this.home;

    this.ifcService.GetIfcReportErrorDataUncached(request)
      .then(response => {
        let listPagedHomeIfcFilesResponse = response as ListPagedIfcErrorsResponse;
        this.homeIfcFileErrors = listPagedHomeIfcFilesResponse.items;
        this.ifcFilesLoading = false;
      })
      .catch(err => {
        this.ifcFilesLoading = false;
      });
  };

  private pollGetIfcFileUploadStatus() {
    if (this._getIfcFileUploadStatusSubscription) {
      this._getIfcFileUploadStatusSubscription.unsubscribe();
    }
    
    this._getIfcFileUploadStatusSubscription = interval(5000)
      .subscribe(() => {
        this.getIfcFileUploadStatus();
      });
  };

  private getIfcFileUploadStatus() {
    let request = new GetIfcFileUploadStatusRequest();
    request.builder = this.selectedCompany?.code;
    request.homeName = this.home.toLowerCase();
    this.situViewClient.getIfcFileUploadStatus(request)
    .then(response => {
      let listIfcFileUploadErrorsResponse = response as GetIfcFileUploadStatusResponse;
      if (listIfcFileUploadErrorsResponse.success) {
        let files = listIfcFileUploadErrorsResponse.tempIfcFiles ?? [];
        let errors = listIfcFileUploadErrorsResponse.tempIfcFileErrors ?? [];
        if (this.tempIfcFiles.length !== files.length || this.tempIfcFileErrors.length !== errors.length) {
          this.loadHomeDetail();
          this.loadIfcReportData();
          this.loadIfcReportErrorData();
          this.tempIfcFiles = files;
          this.tempIfcFileErrors = errors;
        }
      }
    })
    .catch(err => {

    });
  };

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 3000 });
  }
}
